


















import Vue from "vue"
import {EventBus} from "./eventbus"
import nouns from "./data/nouns.json"
import adjectives from "./data/adjectives.json"

// https://stackoverflow.com/a/24597663/51280
function alphabet(charA, charZ) {
  const a = []
  let i = charA.charCodeAt(0)
  let j = charZ.charCodeAt(0)
  for (; i <= j; ++i) {
    a.push(String.fromCharCode(i))
  }
  return a
}

export default Vue.extend({
  data() {
    return {
      wordTypes: ["adjective", "noun"],
      wordType: "noun",
      random: Math.random(),
      locked: false,
      letters: alphabet('a', 'z'),
      letter: 'a',
    }
  },
  computed: {
    word: function () {
      if (this.wordType === "noun") {
        let noun = nouns[this.letter];
        return noun[Math.floor(this.random * noun.length)]
      } else {
        let adjective = adjectives[this.letter];
        return adjective[Math.floor(this.random * adjective.length)]
      }
    }
  },
  created (){
    EventBus.$on('randomise', () => {
      if (!this.locked) {
        this.random = Math.random()
      }
    })
  }
})
